// extracted by mini-css-extract-plugin
export default {"zeroStateMessage":"webpack-concepts-Guidelines-NoWorkToDo-NoWorkToDo-module__zeroStateMessage"};